import { Category, ComboSpec, GenericError, Product } from "@tendercuts/models";
import { OutofStockProducts } from "../../models";

export interface CatalogState {
  catalog: Category[];
  loading: boolean;
  errorMsg: GenericError;
  filteredProducts: Product[];
  allProducts: Product[];
  outOfStockProducts: OutofStockProducts[];
  outOfStockProductsMap: { [id: number]: OutofStockProducts };
  productMap: { [id: number]: Product };
  comboProductsMap: { [id: number]: ComboSpec[] };
  eliteProducts: Product[];
}

export const catalogInitialState: CatalogState = {
  catalog: [],
  loading: false,
  errorMsg: null,
  filteredProducts: [],
  allProducts: [],
  outOfStockProducts: [],
  outOfStockProductsMap: null,
  productMap: null,
  comboProductsMap: null,
  eliteProducts: [],
};

export function catalogTestState(): CatalogState {
  return {
    catalog: [],
    loading: false,
    errorMsg: null,
    filteredProducts: [],
    allProducts: [],
    outOfStockProducts: [],
    outOfStockProductsMap: null,
    productMap: null,
    comboProductsMap: null,
    eliteProducts: [],
  }
};
